angular.module("searchRequestCustomer.components", []).component("searchRequestCustomer", {
    templateUrl: "ng/components/cruscottoRichiestaClienti/searchRequestCustomer/searchRequestCustomer.view.html",
    bindings: {
        onPressSearch: '&',
        appRichiestePostVenditaCount: "<",
        isPending: '<'
    },
    controllerAs: "searchRequestCustomerCtrl",
    controller: function SearchRequestCustomer(
        $typeDomainService,
        $arcService,
        $configService
    ) {
        var self = this;

        self.$onInit = function () {
            self.filter = undefined;
            self.supportModel = {
                idRichiesta: null,
                dataDa: undefined,
                dataA: undefined,
                statoSelezionato: undefined,
                listaStatoRichiesta: undefined,
                ndgCli: null,
                categoriaSelezionata: undefined,
                listaCategorie: undefined,
                tipoRichiestaSelezionata: undefined,
                listaTipoRichiesta: undefined,
                ufficioSelezionato: undefined,
                listaUfficio: undefined,
                vediRichieste: false,
            }

            self.getListaUffici();
            self.getDomainSet();
            self.getDropDownRequestsPv();
        }

        self.handleChange = function (property) {

            switch (property) {
                case 'categoria':
                    if (self.supportModel.categoriaSelezionata) {
                        self.getDropDownRequestsPv(true);
                    } else {
                        self.supportModel.tipoRichiestaSelezionata = undefined;
                    }
                    break;
                case 'ufficio':
                    self.supportModel.categoriaSelezionata = undefined;
                    self.supportModel.tipoRichiestaSelezionata = undefined;
                    self.getDropDownRequestsPv();
                    break;
                default:
                    break;
            }

        }

        self.getStartDate = function (value, mode) {
            if (!value) {
                return;
            }

            if (!mode) {
                return moment(value, "DD/MM/YYYY").add(1, "days").format("DD/MM/YYYY");
            } else {
                return moment(value, "DD/MM/YYYY").format("DD/MM/YYYY");
            }
        }

        self.getDomainSet = function () {
            $typeDomainService.getDomainSet('PRACTICE_PV', 'STATUS_CRUSCOTTO')
                .then(function (response) {
                    self.supportModel.listaStatoRichiesta = response.domainList;
                    //self.supportModel.statoSelezionato = response.domainList[0]
					self.supportModel.statoSelezionato = response.domainList.find(function(el) {
					    return el.value === 'PV100';
					});
                    self.cerca();

                })
        }

        self.getListaUffici = function () {
            $typeDomainService.getDomainSet('PRACTICE_PV', 'RIF_OFFICE')
                .then(function (response) {
                    self.supportModel.listaUfficio = response.domainList;
                })
        }

        self.getDropDownRequestsPv = function (categoriaSelected) {
            var level = self.supportModel.categoriaSelezionata ? 1 : 0;
            var ufficio = self.supportModel.ufficioSelezionato ? self.supportModel.ufficioSelezionato.name : undefined;

            $arcService.getDropDownRequestsPv(
                level,
                'RICHIESTE_POSTVENDITA',
                self.supportModel.categoriaSelezionata,
                true,
                ufficio
            )
                .then(function (response) {
                    if (categoriaSelected) {
                        self.supportModel.listaTipoRichiesta = response;
                    } else {
                        self.supportModel.listaCategorie = response;
                    }

                })
        }


        self.cerca = function () {
            self.filter = {
                limit: 10,
                offset: 0,
                pageIndex: 1,
                totalPages: 0,
                orderColumnName: "UPDATE_DATE",
                orderType: "DESC",
                id: self.supportModel.idRichiesta ? self.supportModel.idRichiesta : undefined,
                startDate: self.supportModel.dataDa,
                endDate: self.supportModel.dataA,
                status: self.supportModel.statoSelezionato ? self.supportModel.statoSelezionato.value : undefined,
                ndgCli: self.supportModel.ndgCli ? self.supportModel.ndgCli : undefined,
                category: self.supportModel.categoriaSelezionata ? self.supportModel.categoriaSelezionata.value : undefined,
                type: self.supportModel.tipoRichiestaSelezionata ? self.supportModel.tipoRichiestaSelezionata.value : undefined,
                showAll: self.supportModel.vediRichieste,
                rifOffice: self.supportModel.ufficioSelezionato ? self.supportModel.ufficioSelezionato.name : undefined
            }

            self.onPressSearch({
                filter: self.filter
            })
        }

        self.exportRichiestePV = function () {
            //imposto il limit a zero per far si che mi esporti tutte le pratiche e non solo quelle della prima pagina
            self.filter.limit = 0;
            /* $arcService.exportRichiestePV(self.filter)
                .then(function (response) {
                    self.downloadFile(response);
                }) */
            self.filter.startDate = self.filter.startDate && self.filter.startDate.replace(/\//gi, '-');
            self.filter.endDate = self.filter.endDate && self.filter.endDate.replace(/\//gi, '-');
            window.open($configService.getUrl() +
                "/arc/exportRichiestePV/service-infos/" +
                encodeURIComponent(JSON.stringify(self.filter)) +
                "/?token=" +
                $configService.getAppConfig().token, "_blank");
            self.filter.startDate = self.filter.startDate && self.filter.startDate.replace(/-/gi, '/');
            self.filter.endDate = self.filter.endDate && self.filter.endDate.replace(/-/gi, '/');
        }

        self.downloadFile = function (response) {
            var a = document.createElement('a');
            var blob = new Blob([response], {
                type: 'text/csv'
            });
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = 'reportCruscottoRichieste.csv';
            a.click();
        }

        self.check = function (el) {
            el.vediRichieste = !el.vediRichieste;
        }

        function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return view;
        }
    }
})